import Immutable from 'seamless-immutable';
import DisplayContainerModel from './display-container-model';
import { baseCollection } from '../../common/collections';

/**
 * Transforms and array of backend display container objects into a DisplayContainerCollection
 * @param {Object[]} displayContainers - backend formatted display containers
 * @returns {DisplayContainer[]}
 */
function deserialize(displayContainers = []) {
  return Immutable(_.map(displayContainers, DisplayContainerModel.deserialize));
}

/**
 * Transforms a DisplayContainerCollection into an array of backend display container objects
 * @param {DisplayContainer[]} displayContainers
 * @param {boolean} isMacroExperience
 * @returns {Object[]}
 */
function serialize(displayContainers, isMacroExperience) {
  return _.map(displayContainers, (displayContainer) =>
    DisplayContainerModel.serialize(displayContainer, isMacroExperience)
  );
}

export default {
  ...baseCollection,
  create: deserialize,
  deserialize,
  serialize,
};
